import { render } from "./LbrxHeader.vue?vue&type=template&id=1cd41c3d"
import script from "./LbrxHeader.vue?vue&type=script&lang=js"
export * from "./LbrxHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__